import { MAX_SEARCH_SPAN_DAYS, searchSpanDays } from 'Modules/BulkBooking/Recurrence';
import { BookingWizardData } from '../../BookingWizardData/BaseBookingWizardData';
import { setWizardData } from '../../BookingWizardDataStore';

export const validateBulkTicketsStep = (wizardData: BookingWizardData, updateErrorState: boolean): boolean => {
	const errors: Record<string, string> = {};
	const filters = wizardData.bulkBookingFilters;

	if (!filters?.startDate) {
		errors.startDate = 'Required';
	} else {
		const today = new Date();
		today.setHours(0, 0, 0, 0);
		if (filters.startDate < today) {
			errors.startDate = 'Must be today onwards';
		}
	}

	if (!filters?.endDate) {
		errors.endDate = 'Required';
	} else if (filters.startDate && filters.endDate <= filters.startDate) {
		errors.endDate = 'Must be after start date';
	} else if (filters.startDate && searchSpanDays(filters.startDate, filters.endDate) > MAX_SEARCH_SPAN_DAYS) {
		// The server rejects a longer span outright — a sparse pattern can match few enough trips
		// to pass the trip limit while still spanning years of schedule to search.
		errors.endDate = `Must be within ${MAX_SEARCH_SPAN_DAYS} days of the start date`;
	}

	if (!filters?.daysOfWeek || filters.daysOfWeek.length === 0) {
		errors.daysOfWeek = 'Select at least one day';
	}

	if (!filters?.interval || filters.interval < 1 || !Number.isInteger(filters.interval)) {
		errors.interval = 'Must be 1 or more';
	}

	// "Friday of every month" is not a date — a monthly pattern needs to say which Friday.
	if (filters?.frequency === 'monthly' && (!filters.weekOrdinals || filters.weekOrdinals.length === 0)) {
		errors.weekOrdinals = 'Select at least one week';
	}

	if (!filters?.departureTime) {
		errors.departureTime = 'Required';
	}

	const isValid = Object.keys(errors).length === 0;

	if (updateErrorState && !isValid) {
		setWizardData(
			new BookingWizardData({
				...wizardData,
				bulkBookingFilters: {
					...filters!,
					errors,
				},
			}),
		);
	}

	return isValid;
};
